export default {
  chooseFile: 'انتخاب فایل',
  uploading: 'در حال آپلود',
  areYouSureToRemoveThisFile: 'آیا از حذف این فایل اطمینان دارید؟',
  squareImageError: {
    single: 'طول و عرض تصویر باید یکسان باشد',
    multiple:
      'یک یا چند عدد از تصاویر عرض و طول یکسان نداشته و قابل انتخاب نیستند'
  },
  uploadCountLimit:
    'تعداد فایل های انتخابی باید کمتر یا مساوی {count} عدد باشد',
  file_max_size_exceeded:
    'حجم فایل "{fileName}" بیشتر از حد مجاز است. فایل هایی با حجمی کمتر از {maxSize} کیلو بایت آپلود کنید.',
  file_extension_not_accepted:
    'نوع فایل "{fileName}" پذیرفته نیست. نوع های قابل پذیرش "{accepted}" است.',
  invalidFileUpload: 'فایل انتخابی معتبر نیست!',
  nothingSelected: 'موردی انتخاب نشده',
  confirm: 'متوجه شدم',
  more: 'بیشتر ...',
  confirmed: 'تایید شده',
  unconfirmed: 'تایید نشده',
  uploadImage: 'بارگذاری تصویر',
  updateImage: 'بروزرسانی تصویر',
  plateIranNumber: 'شماره ایران',
  plateRightNumber: 'شماره راست پلاک',
  plateCharacter: 'حرف پلاک',
  plateLeftNumber: 'شماره چپ پلاک'
}
